import { useReveal } from "../hooks/useReveal";

export const About = () => {
  const ref = useReveal();
  return (
    <section
      id="quienes-somos"
      data-testid="about-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div ref={ref} className="reveal grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#ca0013]" />
              <span className="font-label text-xs text-[#ca0013]">
                Quiénes somos
              </span>
            </div>
            <h2
              data-testid="about-title"
              className="font-display text-4xl md:text-5xl tracking-tight leading-[0.95]"
            >
              Una agencia{" "}
              <span className="font-editorial text-[#ca0013] font-normal">
                pequeña
              </span>
              ,
              <br />
              con resultados{" "}
              <span className="font-editorial text-[#ca0013] font-normal">
                grandes
              </span>
              .
            </h2>
          </div>

          <div className="lg:col-span-8 lg:pl-12 lg:border-l border-black/15">
            <p className="font-body text-lg md:text-xl text-[#111] leading-relaxed">
              En <strong className="font-bold">Vertex House</strong> creemos que
              el marketing no se trata de publicar más, se trata de comunicar
              mejor. Somos un equipo creativo enfocado en negocios que quieren
              crecer con intención: con estrategia, con estética y con datos que
              respalden cada decisión.
            </p>
            <p className="font-body text-base md:text-lg text-[#4a4a4a] leading-relaxed mt-6">
              Trabajamos como una extensión de tu marca. Desde el primer reel
              hasta la campaña que escala tus ventas, cada pieza está pensada
              para que tu negocio se vea — y se sienta — como el referente de su
              categoría.
            </p>

            <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
              {[
                { k: "+50", v: "Proyectos lanzados" },
                { k: "100%", v: "Estrategia a medida" },
                { k: "24/7", v: "Soporte directo" },
              ].map((s, i) => (
                <div key={i} data-testid={`about-stat-${i}`}>
                  <div className="font-editorial text-5xl md:text-6xl text-[#ca0013] leading-none">
                    {s.k}
                  </div>
                  <div className="font-label text-xs text-[#4a4a4a] mt-3">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
